function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useReducer, useContext, useEffect } from 'react';
import environment from "./environment";
import Cookie from "../components/security/cookie";
import object from "./utils/object";
import logger from "./logger";
import Translator from "./translator";
/**
 * Les valeurs par défaut du contexte.
 *
 * @type {object}
 */

export var context = {
  locale: navigator.language || environment.get('default_locale'),
  editionMode: false,
  documents: [],
  update: function update(state) {
    for (var prop in state) {
      if (!state.hasOwnProperty(prop)) {
        continue;
      }

      if (this) {
        this[prop] = state[prop];
      }
    }
  }
};
/**
 * Creation du contexte principal utilisé dans toutes les applications wever.
 */

export var Context = /*#__PURE__*/React.createContext(context);
/**
 * Hook d'appel au context global
 */

export var useGlobalContext = function useGlobalContext() {
  return useContext(Context);
};
/**
 * Affiche le nom utilisé par l'outil de dev
 *
 * @see https://fr.reactjs.org/docs/context.html#contextdisplayname
 */

Context.displayName = 'CoreAppContext';
/**
 * Affiche les valeurs du contexte.
 *
 * Vous pouvez accéder les propriétés imbriquées
 * en utilisant des points "." entre chaque propriétés d'objet
 *
 * @example: <Context.Display path="theme.color" />
 */

Context.Display = function (_ref) {
  var path = _ref.path;
  return /*#__PURE__*/React.createElement(Context.Consumer, null, function (values) {
    return object.get(path, values);
  });
};

export var Provider = function Provider(_ref2) {
  var value = _ref2.value,
      aliasCookie = _ref2.aliasCookie,
      children = _ref2.children,
      _ref2$typeCookie = _ref2.typeCookie,
      typeCookie = _ref2$typeCookie === void 0 ? 'allPage' : _ref2$typeCookie;

  var _useReducer = useReducer(function (s, a) {
    return a;
  }, _objectSpread(_objectSpread({}, value), {}, {
    isCookieValidated: false,
    events: {}
  })),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      contextValue = _useReducer2[0],
      dispatch = _useReducer2[1];

  var handleUpdate = function handleUpdate(newContext) {
    dispatch(_objectSpread(_objectSpread({}, contextValue), newContext));
  };

  useEffect(function () {
    if (contextValue.locale !== value.locale) {
      Translator.setLocale(value.locale);
      handleUpdate({
        locale: value.locale
      });
    }
  }, [value.locale]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: _objectSpread(_objectSpread({}, contextValue), {}, {
      update: handleUpdate
    })
  }, contextValue.isCookieValidated || !aliasCookie ? children : /*#__PURE__*/React.createElement(Cookie, {
    alias: aliasCookie,
    type: typeCookie
  }));
};
export default Context;